import * as React from 'react';
import AmCharts from "@amcharts/amcharts3-react";
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { Proto, Props, State } from '@src/components/Proto';
import { Ratio, Box } from '@src/components';

// typing

// style
const style = css`
    display: flex;
    > * {
        width: 50%;
        padding: 10px;
    }

    nav {
        display: flex;
        justify-content: space-between;

        > article {
            display: flex;
            > span {
                &:first-child {
                    width: 20px;
                    height: 20px;
                    border-radius: 10px;
                }
                &:last-child {
                    padding-left: 10px;
                    > strong {
                        font-size: 24px;
                        font-weight: 500;
                    }
                    > p {
                        margin: 0,
                    }
                }
            }
        }
    }

    .table {
        tr {
            > td {
                vertical-align: middle;
                &:first-child {
                    text-align: center;
                    > img {
                        height: 50px;
                    }
                }
                &:last-child {
                    text-align: right;
                    > span {
                        display: inline-block;
                        width: 120px;
                        margin-right: 30px;
                        padding: 5px;
                        text-align: center;
                        background: #d4d3d3;
                        border-radius: 5px;
                    }
                }
            }
        }
        i {
            font-size: 20px;
        }
    }
`;

// component
export class LastCycle extends Proto<Props, State> {

	// render
	render() {
        const loading = this.loading();
        if (loading) return loading;
        const { data } = this.state;
        const { count, cycle } = data.data;

        const total = count.completedcnt + count.partialcnt;
        const graphData = [{
            message: _('lastcycles_graph_completed', 'BatteryOverview'),
            val: count.completedcnt,
            percent: count.completed,
            color: vars.colors.green
        }, {
            message: _('lastcycles_graph_notcompleted', 'BatteryOverview'),
            val: count.partialcnt,
            percent: count.partial,
            color: vars.colors.orange
        }];

        const config = {
            "type": "pie",
            "labelsEnabled": false,
            "theme": "light",
            "titleField": "message",
            "valueField": "percent",
            "colorField": "color",
            "outlineAlpha": 0.4,
            "depth3D": 15,
            "angle": 30,
            "balloonText": "[[title]]: [[percents]]%",
            dataProvider: graphData
        };
        for (let i=0; i<12; i++) {}
        
		return (
            <Box title="Last cycle" collapsed={false}>
                <div className={style}>
                    <article>
                        <table className="table"><tbody>
                        <tr>
                            <td><img src="/files/icons2/charge2.svg" /></td>
                            <td>{_('lastcycles_cycletype', 'BatteryOverview')}</td>
                            <td><span>{cycle.cycletype != null ? cycle.cycletype : "-"}</span></td>
                        </tr>
                        <tr>
                            <td><img src="/files/icons2/gauge_medium.svg" /></td>
                            <td>{_('lastcycles_startvoltage', 'BatteryOverview')}</td>
                            <td><span>{cycle.startvoltage != null ? cycle.startvoltage : "- "} V</span></td>
                        </tr>
                        <tr>
                            <td><img src="/files/icons2/gauge_low.svg" /></td>
                            <td>{_('lastcycles_endvoltage', 'BatteryOverview')}</td>
                            <td><span>{cycle.endvoltage != null ? cycle.endvoltage : "- "} V</span></td>
                        </tr>
                        <tr>
                            <td><img src="/files/icons2/battery_full.svg" /></td>
                            <td>{_('lastcycles_chargedah', 'BatteryOverview')}</td>
                            <td><span>{cycle.chargedah != null ? cycle.chargedah : "- "} Ah</span></td>
                        </tr>
                        <tr>
                            <td><img src="/files/icons2/charge_full.svg" /></td>
                            <td>{_('lastcycles_endsoc', 'BatteryOverview')}</td>
                            <td><span>{cycle.endsoc != null ? cycle.endsoc : "- "}%</span></td>
                        </tr>
                        <tr>
                            <td><img src="/files/icons2/temp2.svg" /></td>
                            <td>{_('lastcycles_endtemp', 'BatteryOverview')}</td>
                            <td><span>{cycle.endtemp != null ? cycle.endtemp : "- "} °C</span></td>
                        </tr>
                        <tr>
                            <td><img src="/files/icons2/balance.svg" /></td>
                            <td>{_('lastcycles_balancing', 'BatteryOverview')}</td>
                            <td><span>{cycle.balancing != null ? `${_(cycle.balancing, 'BatteryOverview')} (${cycle.maxdeltav}V)` : "-"}</span></td>
                        </tr>
                        <tr>
                            <td><img src="/files/icons2/cycle.svg" /></td>
                            <td>{_('lastcycles_completedcnt', 'BatteryOverview')}</td>
                            <td><span>{count.completedcnt != null ? count.completedcnt : "-"}</span></td>
                        </tr>
                        <tr>
                            <td><img src="/files/icons2/clock_start.svg" /></td>
                            <td>{_('lastcycles_cycle_devtime', 'BatteryOverview')}</td>
                            <td><span>{cycle.cycle_devtime != null ? cycle.cycle_devtime : "-"}</span></td>
                        </tr>
                        <tr>
                            <td><img src="/files/icons2/clock_stop.svg" /></td>
                            <td>{_('lastcycles_cycle_endtime', 'BatteryOverview')}</td>
                            <td><span>{cycle.cycle_endtime != null ? cycle.cycle_endtime : "-"}</span></td>
                        </tr>
                        </tbody></table>
                    </article>
                    <article>
                        <nav>
                            {graphData.map( (v,i) => (
                            <article key={i}>
                                <span style={{backgroundColor: v.color}} />
                                <span>
                                    <strong>{v.val} ({formatters.percent(v.percent, 100)}%)</strong>
                                    <p>{v.message}</p>
                                </span>
                            </article>
                            ))}
                        </nav>
                        <Ratio w={16} h={9}>
                            <AmCharts.React style={{ width: "100%", height: "100%" }} options={config} />
                        </Ratio>
                    </article>
                </div>
            </Box>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/BatteryOverview/LastCycle.tsx